{
  "version": 1,
  "asset_id": "17bdd29d-7422-4ef1-8956-67153bee6739",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/17bdd29d-7422-4ef1-8956-67153bee6739/beylikduzu-hizli-elektrikci-7-24-dukkan-2.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/17bdd29d-7422-4ef1-8956-67153bee6739/beylikduzu-hizli-elektrikci-7-24-dukkan-2.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-2.jpg",
  "size": 382853,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:32Z"
}
